(function (angular) {
    angular
        .module('harriApp')
        .controller('getJobAlertsModal', [
            '$scope', '$state', 'modalData', '$filter', 'CareerPortalDataBus', 'positionsDataService',
            function ($scope, $state, modalData, $filter, CareerPortalDataBus, positionsDataService) {

                $scope.modalData = modalData;
                $scope.source =  modalData.source;
                $scope.isFormShown = $scope.source === 'CUSTOM_JOB_SEARCH'? !!$scope.brand : true;
                $scope.getJobAlertsForm = new GetJobAlertForm($scope, CareerPortalDataBus, positionsDataService);

                const loadFrom = (selectedBrand) => {
                    $scope.getJobAlertsForm.load({
                        brand: selectedBrand,
                        position_code: modalData.position_code,
                        source: $scope.modalData.source
                    });
                }

                if ($scope.source === 'CUSTOM_JOB_SEARCH') {
                    $scope.locations = $scope.modalData.listOfLocations;
                } else {
                    $scope.brand = modalData.brand;
                    loadFrom($scope.brand);
                }

                $scope.saving = false;

                $scope.submit = function () {
                    $scope.saving = true;

                    $scope.getJobAlertsForm.validator.validate(function (isValid) {
                        if (isValid) {
                            $scope.getJobAlertsForm.save($scope.brand.id)
                                .then(function (res) {
                                    modalData.onSuccess && modalData.onSuccess({'res': res, 'brand': $scope.brand});
                                    delete $scope.saving;
                                    $scope.close();
                                    $scope.$digest();
                                }, function (err) {
                                    modalData.onError && modalData.onError(err, $scope.getJobAlertsForm.data.email, $scope.brand);
                                    console.error(err);
                                    delete $scope.saving;
                                    $scope.$digest();
                                });
                        } else {
                            $scope.saving = false;
                        }
                    });
                };

                //Hide modal
                $scope.close = function () {
                    $scope.$hide();
                };

                $scope.locationsFilterChanged = () => {
                    $scope.getJobAlertsForm.validator.validation = {};
                    if ($scope.selectedLocation) {
                        $scope.brand = $scope.selectedLocation;
                        $scope.isFormShown = true;
                        loadFrom($scope.selectedLocation);
                    } else {
                        $scope.isFormShown = false;
                    }
                }

            }]);
})(angular);
